import dayjs from "dayjs";

export const formatDisplayDate = (date) => {
  if (!date) return "-";

  return dayjs(date).format("MMM DD, YYYY");
};